// extracted by mini-css-extract-plugin
export var printerCard = "_hd-1";
export var printerCardConfigured = "_hd-2";
export var printerCardError = "_hd-3";
export var printerCardsContainer = "_hd-0";
export var printerIcon = "_hd-8";
export var printerIconConfigured = "_hd-5";
export var printerIconContainer = "_hd-4";
export var printerIconError = "_hd-6";
export var printerIconUnconfigured = "_hd-7";
export var workstationsTableCard = "_hd-9";